module.exports = __webpack_public_path__ + "media/newsletter_page/what_describes_you-2613fd55.svg";